import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

/**
 * Universal back-link. Uses browser history when there's something to go back to,
 * otherwise falls back to a sensible parent route (or `/`).
 * Render it near the top of any nested page so users aren't trapped.
 */
export default function BackLink({ fallbackTo = "/", label = "Back", className = "" }) {
  const navigate = useNavigate();
  const location = useLocation();

  const onClick = () => {
    // window.history.length is 1 when the user landed here directly (new tab / QR scan)
    if (window.history.length > 1 && location.key !== "default") {
      navigate(-1);
    } else {
      navigate(fallbackTo);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 text-sm font-mono uppercase tracking-widest text-zinc-500 hover:text-zinc-950 transition-colors ${className}`}
      data-testid="back-link"
    >
      <ArrowLeft size={14} weight="bold" /> {label}
    </button>
  );
}
